<div class="agent-chat-overlay" *ngIf="chat.isOpen()" (click)="chat.close()"></div>

<aside class="agent-chat-panel" [class.open]="chat.isOpen()" role="dialog" aria-label="DB Query Agent">
  <header class="agent-chat-header">
    <div class="agent-chat-title">
      <span class="agent-chat-dot"></span>
      DB Query Agent
    </div>
    <div class="agent-chat-header-actions">
      <button type="button" class="btn-icon" (click)="chat.reset()" title="New conversation" aria-label="New conversation">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>
      </button>
      <button type="button" class="btn-icon" (click)="chat.close()" title="Close" aria-label="Close">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
  </header>

  <div class="agent-chat-messages">
    <div *ngIf="chat.messages().length === 0" class="agent-chat-empty">
      <p><strong>Ask anything about your data.</strong></p>
      <p class="text-muted">Examples:</p>
      <ul>
        <li>"How many leads were added this month?"</li>
        <li>"List my top 5 properties by rent."</li>
        <li>"Show me unpaid bills due in the next 7 days."</li>
      </ul>
      <p class="text-muted small">Only SELECT queries are executed, scoped to what your role can see.</p>
    </div>

    <ng-container *ngFor="let msg of chat.messages(); let i = index">
      <div class="msg" [class.msg-user]="msg.role === 'user'" [class.msg-assistant]="msg.role === 'assistant'">
        <div class="msg-bubble">
          <ng-container *ngIf="msg.pending">
            <span class="typing"><span></span><span></span><span></span></span>
          </ng-container>

          <ng-container *ngIf="!msg.pending && msg.error">
            <div class="msg-error">⚠️ {{ msg.error }}</div>
          </ng-container>

          <ng-container *ngIf="!msg.pending && !msg.error">
            <div class="msg-content">{{ msg.content }}</div>

            <details *ngIf="msg.sql && canSeeSql" class="msg-sql">
              <summary>Show SQL</summary>
              <pre><code>{{ msg.sql }}</code></pre>
            </details>

            <div *ngIf="msg.rows && msg.rows.length > 0" class="msg-table-wrap">
              <table class="msg-table">
                <thead>
                  <tr>
                    <th *ngFor="let c of columnsOf(msg.rows)">{{ c }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of msg.rows.slice(0, 50)">
                    <td *ngFor="let c of columnsOf(msg.rows)">{{ row[c] }}</td>
                  </tr>
                </tbody>
              </table>
              <div *ngIf="msg.rows.length > 50" class="msg-table-more text-muted small">
                Showing 50 of {{ msg.rows.length }} rows.
              </div>
            </div>

            <div *ngIf="msg.tookMs !== undefined && msg.role === 'assistant'" class="msg-meta text-muted small">
              {{ msg.tookMs }}ms
              <ng-container *ngIf="msg.toolCallCount">· {{ msg.toolCallCount }} SQL call{{ msg.toolCallCount === 1 ? '' : 's' }}</ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <div #scrollAnchor></div>
  </div>

  <form class="agent-chat-input" (submit)="$event.preventDefault(); send()">
    <textarea
      [(ngModel)]="question"
      name="question"
      placeholder="Ask about your data... (Enter to send)"
      rows="2"
      [disabled]="chat.isPending()"
      (keydown)="onKey($event)"
    ></textarea>
    <button type="submit" class="btn-send" [disabled]="chat.isPending() || !question.trim()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
    </button>
  </form>
</aside>
